import { render, staticRenderFns } from "./Pets.vue?vue&type=template&id=7138b006"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports